/**
 * DiscoveryOrdering (AJIP-16.02.005 · WS9)
 * ---------------------------------------------------------------------
 * Deterministic ordering: priority ASC → name ASC → id ASC → version DESC.
 * The same input always produces the same output. No AI, no engagement,
 * no paid ranking (per WS9 explicit prohibitions).
 */
const orderJourneys = (defs) => {
  const list = Array.isArray(defs) ? [...defs] : [];
  list.sort((a, b) => {
    const pa = Number.isInteger(a.priority) ? a.priority : Number.MAX_SAFE_INTEGER;
    const pb = Number.isInteger(b.priority) ? b.priority : Number.MAX_SAFE_INTEGER;
    if (pa !== pb) return pa - pb;
    const na = String(a.journeyName || '');
    const nb = String(b.journeyName || '');
    if (na !== nb) return na < nb ? -1 : 1;
    const ia = String(a.journeyId || '');
    const ib = String(b.journeyId || '');
    if (ia !== ib) return ia < ib ? -1 : 1;
    return (b.journeyVersion || 0) - (a.journeyVersion || 0);
  });
  return Object.freeze(list);
};

export { orderJourneys };
